import { Route, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';
import CenteredLayout from '../layouts/Centered';
import RootLayout from '../layouts/Root';
import FullscreenRootLayout from '../layouts/FullscreenRoot';
import ConsultasPage from '../pages/ConsultasPage';
import DashboardPage from '../pages/DashboardPage';
import LoginPage from '../pages/LoginPage';
import OrganizationManagerPage from '../pages/OrganizationManagerPage';
import OrganizationSettingsPage from '../pages/OrganizationSettingsPage';
import OrganizationSetupPage from '../pages/OrganizationSetupPage';
import PasswordPage from '../pages/PasswordPage';
import SignupPage from '../pages/SignupPage';
import EmailVerificationPage from '../pages/EmailVerificationPage';
import ForgotPasswordPage from '../pages/ForgotPasswordPage';
import PacientesPage from '../pages/PacientesPage';
import ProtectedRoute from '../pages/ProtectedPage';
import UsersPage from '../pages/UsersPage';
import AtendimentosPage from '../pages/AtendimentosPage';
import Consultas from '../templates/Consultas';
import ConsultasById from '../templates/ConsultasById';
import ConsultasPrintById from '../templates/ConsultasPrintById';
import PacientesById from '../templates/PacienteById';
import Pacientes from '../templates/Pacientes';
import Users from '../templates/Users';
import AtendimentosFila from '../templates/AtendimentosFila';
import AtendimentosConsultorio from '../templates/AtendimentosConsultorio';
import AtendimentosMonitor from '../templates/AtendimentosMonitor';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route element={<RootLayout />}>
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute requiredRole="saasadmin" checkGlobalRole={true} redirectTo="/">
              <OrganizationManagerPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/org"
          element={
            <ProtectedRoute requiredRole="owner" redirectTo="/">
              <OrganizationSettingsPage />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route element={<RootLayout />}>
        <Route
          path="/pacientes"
          element={
            <ProtectedRoute>
              <PacientesPage />
            </ProtectedRoute>
          }
        >
          <Route path="/pacientes" element={<Pacientes />} />
          <Route path="/pacientes/:id" element={<PacientesById />} />
        </Route>
        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <UsersPage />
            </ProtectedRoute>
          }
        >
          <Route path="/users" element={<Users />} />
        </Route>
        <Route
          path="/consultas"
          element={
            <ProtectedRoute>
              <ConsultasPage />
            </ProtectedRoute>
          }
        >
          <Route path="/consultas" element={<Consultas />} />
          <Route path="/consultas/:id" element={<ConsultasById />} />
        </Route>
        <Route
          path="/atendimentos"
          element={
            <ProtectedRoute>
              <AtendimentosPage />
            </ProtectedRoute>
          }
        >
          <Route path="/atendimentos/fila" element={<AtendimentosFila />} />
          <Route path="/atendimentos/consultorio" element={<AtendimentosConsultorio />} />
        </Route>
      </Route>
      <Route element={<FullscreenRootLayout />}>
        <Route
          path="/atendimentos/monitor"
          element={
            <ProtectedRoute>
              <AtendimentosMonitor />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route>
        <Route
          path="/consultas/print/:id"
          element={
            <ProtectedRoute>
              <ConsultasPrintById />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route element={<CenteredLayout />}>
        <Route path="login" element={<LoginPage />} />
        <Route path="signup" element={<SignupPage />} />
        <Route path="forgot-password" element={<ForgotPasswordPage />} />
        <Route path="password" element={<PasswordPage />} />
        <Route path="organization-setup" element={<OrganizationSetupPage />} />
        <Route path="verify-email" element={<EmailVerificationPage />} />
      </Route>
    </Route>
  )
);

export default router;
